import script from "./BaseFormMixin.vue?vue&type=script&lang=ts"
export * from "./BaseFormMixin.vue?vue&type=script&lang=ts"

export default script